// Vendor
import * as React from 'react';
import { BarItemProps } from '@nivo/bar';

const Bar: React.FC<BarItemProps> = (props) => {
  const { data, color, height, label, width, x, y } = props;
  const { indexValue, value } = data;
  const isPositive = value > 0;

  const barLabel = (
    <g transform={`translate(${x + width / 2}, 0)`}>
      <text
        className="text-sm"
        dominantBaseline="central"
        textAnchor="middle"
        x={0}
        y={-45}
      >
        {indexValue}
      </text>
    </g>
  );

  return (
    <>
      {isPositive && barLabel}
      <g transform={`translate(${x}, ${y})`}>
        <rect
          fill={color}
          height={height}
          stroke="white"
          strokeWidth="0"
          width={width}
        />

        <text
          className="font-bold text-sm"
          dominantBaseline="central"
          textAnchor="middle"
          x={width / 2}
          y={isPositive ? -16 : height + 16}
        >
          {`${isPositive ? label : Number(label) * -1}%`}
        </text>
      </g>
    </>
  );
};

export { Bar };
